import axios from 'axios';

const addAppointment = (data) =>
  axios
    .post(`${process.env.REACT_APP_API_URL}/api/appointment/addAppointment`, data)
    .then(res => res)
    .catch(err => err);

export default addAppointment;
